import Layout from '@layout/Index'

export const platformUser = [
  {
    path: '/platform-user',
    component: Layout,

    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "PlatformUserTable" */ './pages/PlatformUserTable.vue'),
        name: '后台用户管理',
        meta: {
          title: '后台用户管理',
        },
      },
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "PlatformUserForm" */ './pages/PlatformUserForm.vue'),
        name: '新增后台用户',
        meta: {
          title: '新增后台用户',
        },
      },
      {
        path: 'update/:userId',
        component: () => import(/* webpackChunkName: "PlatformUserForm" */ './pages/PlatformUserForm.vue'),
        name: '编辑后台用户',
        meta: {
          title: '编辑后台用户',
        },
      },
      {
        path: 'allot-many',
        component: () => import(/* webpackChunkName: "PlatformUserAllotManyForm" */ './pages/PlatformUserAllotManyForm.vue'),
        name: '批量分配客户',
        meta: {
          title: '批量分配客户',
        },
      },
      {
        path: 'ui-permissions/:id',
        component: () => import(/* webpackChunkName: "PlatformUserUIPermissions" */ './pages/PlatformUserUIPermissions.vue'),
        name: 'UI权限管理',
      },
      {
        path: 'audit-log',
        component: () => import(/* webpackChunkName: "PlatformUserUIPermissions" */ './pages/AuditLogTable.vue'),
        name: '审计日志',
      },
      {
        path: 'dispatch-roles/:type',
        component: () => import(/* webpackChunkName: "PlatformUserDIspatchRolesPermissions" */ './pages/PlatformUserRoleForm'),
        name: '批量分配权限角色',
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/platform-user/platform-user.route.js